import { render, staticRenderFns } from "./sigmaIcon.vue?vue&type=template&id=34ca2126&"
import script from "./sigmaIcon.vue?vue&type=script&lang=js&"
export * from "./sigmaIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports